var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"adddbe0ff5dc4d3afa676a6770893a517f2376d4"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["archivizer-com@archivizer"]={id:"adddbe0ff5dc4d3afa676a6770893a517f2376d4"};
      